import {
  PARTICIPANT_SEGMENTS,
  ParticipantEnum,
  ROUTES
} from '@/constants/common';

const { RESUMES, HOME } = ROUTES;

export const PLURAL_SEGMENT: Record<
  ParticipantEnum,
  (typeof PARTICIPANT_SEGMENTS)[keyof typeof PARTICIPANT_SEGMENTS]
> = {
  [ParticipantEnum.RESUME]: PARTICIPANT_SEGMENTS.RESUMES,
  [ParticipantEnum.VACANCY]: PARTICIPANT_SEGMENTS.VACANCIES
};

export const RESUME_DETAILS_REGEX = /^\/resumes\/\d+/;
export const VACANCY_DETAILS_REGEX = /^\/vacancies\/\d+/;

export const PARTICIPANT_TABS = [
  {
    id: 'vacancy' as const,
    participant: ParticipantEnum.VACANCY
  },
  {
    id: 'resume' as const,
    participant: ParticipantEnum.RESUME
  }
];

export const ROUTE_BY_PARTICIPANT = {
  [ParticipantEnum.RESUME]: RESUMES,
  [ParticipantEnum.VACANCY]: HOME
};
